module.exports = __webpack_public_path__ + "img/check-list.cfdbca69.svg";